import {
    GET_NEW_RETURN_CUSTOMER_LOADING,
    GET_NEW_RETURN_CUSTOMER_SUCCESS

} from '../actions/NewReturnCustomer';

const initialState = {
    amazon: {
        newReturnCustomerData: null,
        isLoading: true,
    },
    shopify: {
        newReturnCustomerData: null,
        isLoading: true,
    },
    wholesale: {
        newReturnCustomerData: null,
        isLoading: true,
    },
};

const NewReturnCustomerReducer = (state = initialState, action = {}) => {
    switch (action.type) {
        case GET_NEW_RETURN_CUSTOMER_SUCCESS:
            return {
                ...state, [action?.vendor]: { newReturnCustomerData: action.data, isLoading: false }
            };

        case GET_NEW_RETURN_CUSTOMER_LOADING:
            return { ...state, [action?.vendor]: { ...state?.[action?.vendor], isLoading: action.isLoading } };

        default:
            return state;
    }
};

export default NewReturnCustomerReducer;
